export interface FooterAppMenuOpenState {
    routeBeforeMenu: string | null;
    navigateCommands: string[] | null;
}

export interface FooterAppMenuCloseNavigation {
    navigateByUrl: string | null;
    navigateCommands: string[] | null;
}

export enum FooterAppMenuAction {
    CloseMobileMenu = 'closeMobileMenu',
    HandleExploreClick = 'handleExploreClick'
}
